export const uploadStatus = {
    none: 'none',
    ready: 'ready',
    uploading: 'uploading'
};
